import React, { useMemo } from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Label } from 'recharts';

import Spinner from '../common/Spinner';
import Maybe from '../common/Maybe';
import CurrencyFormat from 'utils/currencyFormat';
import { useMediaQuery } from 'hooks/useMediaQuery';

const HowYouSpentChart = ({ loading, data, totalExpenceAmount, colors }) => {
    const isTablet = useMediaQuery('(min-width: 1025px) and (max-width: 1350px)');
    const isMediumScreen = useMediaQuery('(max-width: 1024px)');
    const isSmallMobile = useMediaQuery('(max-width: 380px)');
    const isReallySmallMobile = useMediaQuery('(max-width: 300px)');
    const isSmallestMobile = useMediaQuery('(max-width: 250px)');
    
    const emptyData = [
        { name: 'Empty', value: 1, percentage: 100, color: '#E5E7EB' },
    ];
    
    const pieChartData = useMemo(() => {
        if (data?.length === 0) return [];
        
        return data?.map((expenseData) => ({
            ...expenseData,
            value: expenseData.value / 100,
        }))
    }, [data]);

    // const isEmpty = data?.length === 0;
    const isEmpty = useMemo(() => {
        if (data?.length === 0) return true;
        
        const emptyData = data?.filter((d) => d?.value === 0 && d?.percentage === 0);
        return emptyData?.length === data?.length;
    }, [data]);

    return (
        <>
            <Maybe condition={loading}>
                <Spinner />
            </Maybe>

            <Maybe condition={!loading}>
                <div className="w-full flex items-center flex-wrap lg:flex-nowrap">
                    <div style={{ width: '100%', height: '300px' }}>
                        <ResponsiveContainer>
                            <PieChart>
                                <defs>
                                    <filter id="shadow" x="-50%" y="-50%" width="200%" height="200%">
                                        <feDropShadow dx="0" dy="0" stdDeviation="5" floodColor="#000" floodOpacity="0.1" />
                                    </filter>
                                </defs>
                                <Pie
                                    data={isEmpty ? emptyData : pieChartData}
                                    cx="50%"
                                    cy="50%"
                                    innerRadius={isSmallestMobile ? 60 : isReallySmallMobile ? 70 : isSmallMobile ? 90 : isTablet ? 110 : isMediumScreen ? 130 : 120}
                                    outerRadius={isSmallestMobile ? 75 : isReallySmallMobile ? 85 : isSmallMobile ? 110 : isTablet ? 130 : isMediumScreen ? 150 : 140}
                                    fill="#8884d8"
                                    paddingAngle={isEmpty ? 0 : 6}
                                    cornerRadius={10}
                                    filter="url(#shadow)"
                                    dataKey="value"
                                >
                                    {(isEmpty ? emptyData : pieChartData)?.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={isEmpty ? '#E5E7EB' : colors[index % colors.length]} />
                                    ))}
                                    <Label
                                        value={isEmpty ? "No Data Available Yet" : "Total Expenses"}
                                        position="center"
                                        dy={-20}
                                        style={{
                                            fontSize: '14px',
                                            fill: '#555',
                                            fontWeight: 'light'
                                        }} />
                                    <Label
                                        value={isEmpty ? "Your data will appear here" : CurrencyFormat(totalExpenceAmount / 100 || 0)}
                                        position="center"
                                        dy={10}
                                        style={{
                                            fontSize: isEmpty ? "14px" : isSmallestMobile ? "11px" : isReallySmallMobile ? "13px" : isSmallMobile ? "15px" : isTablet ? "19px" : "clamp(14px, 22px, 32px)",
                                            fill: isEmpty ? "#555" : '#000',
                                            fontWeight: isEmpty ? "light" : 'bold'
                                        }} 
                                    />
                                    {
                                        isEmpty && (
                                            <>
                                                <Label
                                                    value="once you complete a"
                                                    position="center"
                                                    dy={30}
                                                    style={{
                                                        fontSize: '14px',
                                                        fill: '#555',
                                                        fontWeight: 'light'
                                                    }} 
                                                />
                                                <Label
                                                    value="transaction"
                                                    position="center"
                                                    dy={50}
                                                    style={{
                                                        fontSize: '14px',
                                                        fill: '#555',
                                                        fontWeight: 'light'
                                                    }} 
                                                />
                                            </>
                                        )
                                    }
                                </Pie>
                                <Tooltip />
                            </PieChart>
                        </ResponsiveContainer>
                    </div>
                </div>
            </Maybe>
        </>
        )
}

export default HowYouSpentChart